import { instanceOf, string } from 'prop-types'
import cn from 'classnames'

import SocialCommerce from '../../theme-components/social-commerce.js'
import SocialIconAndText from './social-icon-and-text.js'
import UserProfileImage from '../../theme-components/user-profile-image.js'
import UserRealName from './user-real-name.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'
import setTransparency from '../../../../utilities/setTransparency.js'

export default function GridFeedPostOverlay({ settings, post, feedKey }) {
  const { displayName, postAge, showPlatformIcon, showProfileImage } = settings
  const showContributor = displayName || postAge || showPlatformIcon || showProfileImage

  if (!(showContributor || post.socialCommerceEnabled)) {
    return null
  }

  const backgroundColor = setTransparency(settings.postBackgroundColor, '80')
  const { postColor, smallFontSize } = settings

  const postStyles = {
    backgroundColor,
    color: postColor,
    fontSize: smallFontSize,
  }

  const { allowCookies, enableWebAnalytics, socialCommerceButtonLarge } = settings
  const { key, ...restPostProps } = post
  return (
    <div className="bzfy-c-tilegrid-post__overlay" style={postStyles}>
      <div className="bzfy-c-tilegrid-post__profile bzfy-pack">
        {showProfileImage ? (
          <div
            aria-hidden="true"
            className="bzfy-c-tilegrid-post__profile-content-block bzfy-c-tilegrid-post__profile-avatar-container bzfy-pack__item"
          >
            <UserProfileImage
              key={key}
              {...restPostProps}
              className="bzfy-c-tilegrid-post__profile-avatar"
              source={post.sourceName}
            />
          </div>
        ) : null}
        <UserRealName post={post} settings={settings} />
        {post.socialCommerceEnabled ? (
          <SocialCommerce
            allowCookies={allowCookies}
            className={cn('bzfy-c-tilegrid-button', {
              'bzfy-c-tilegrid-button--large': socialCommerceButtonLarge,
            })}
            divClassName="bzfy-c-tilegrid-post__profile-content-block bzfy-pack__item"
            enableWebAnalytics={enableWebAnalytics}
            feedKey={feedKey}
            post={post}
            settings={settings}
          />
        ) : null}
      </div>
      <SocialIconAndText post={post} settings={settings} />
    </div>
  )
}

GridFeedPostOverlay.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
